import { COURSE_TYPES } from 'constants/common';

export const convertDataToApi = (data) => ({
  type: COURSE_TYPES.COURSE,
  platform: data.platform.value,
  schoolId: data.school.value,
});
